import useSWR from "swr";
import { type User } from "../types";
import { simpleFetcher } from "../fetcher";

function useUsers(userId?: number | string) {
  const url = userId ? `/api/v2/users/${userId}` : null;

  return useSWR<User, Error>(url, simpleFetcher, {
    revalidateOnFocus: false,
  });
}

export default useUsers;
